module.exports = __webpack_public_path__ + "img/banner03.b462caf1.jpg";